module.exports = __webpack_public_path__ + "img/banner.dbbe5d26.png";